import { CANDIDATE_FIELD_CONFIG } from '~/consts/candidates';
import { getStore } from '~/mobx/AppStore';

export const getCandidateRowFields = () => {
    const adminStore = getStore().adminStore;

    const jobPositionCity = adminStore.getElectionJobPositionCity();

    let rowFields = [...CANDIDATE_FIELD_CONFIG];
    if (jobPositionCity === 'city') {
        rowFields = rowFields.filter((field) => field.id !== 'occupation');
    } else {
        rowFields = rowFields.filter((field) => field.id !== 'city');
    }

    return rowFields;
};
